<form [formGroup]="form" (ngSubmit)="submit()">
<h2 mat-dialog-title>Task End Reason</h2>
<mat-dialog-content class="mat-typography">
<div>

        <div>
            <div>
                <label>Please provide a reason for ending the task.</label>
                <mat-radio-group formControlName="reasonRadio" class="radio-group">
                    <mat-radio-button [value]="reason" [checked]="i === 0"  class="radio-button" *ngFor="let reason of endOrDeleteReasons; let i = index">
                        {{reason}}
                    </mat-radio-button>
                </mat-radio-group>
            </div>
            <div>
                <mat-label>Driver Notes</mat-label> <br>
                <mat-form-field appearance="outline" class="notes" subscriptSizing="dynamic">
                <textarea #notes matInput formControlName="notes"></textarea>
                </mat-form-field>
            </div>
        </div>
        <div *ngIf="isNoteRequired()" class="alert alert-warning">
            <div>A note is required for 'Other' reason.</div>
        </div>

</div>
</mat-dialog-content>
<mat-dialog-actions align="end">
    <button  mat-flat-button [mat-dialog-close]="false">Cancel</button>
    <button  mat-flat-button type="submit" [disabled]="isNoteRequired()" color="primary">Submit</button>
</mat-dialog-actions>
</form>